import { BitfRestPathBuilder } from '@bitf/core/parsers/rest-parser';

export class AppPathBuilder extends BitfRestPathBuilder {}
